module.exports = __webpack_public_path__ + "img/moi.883a3bc5.jpg";